import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const updateContactName = async ({ chatRoomId, callerName }: { chatRoomId: string; callerName: string }) => {
  const response = await mutationExecute({
    variables: {
      chatRoomId,
      callerName,
    },
    mutation: graphql(`
      mutation UpdateContactName($chatRoomId: String!, $callerName: String) {
        updateContactName(chatRoomId: $chatRoomId, callerName: $callerName)
      }
    `),
  });

  return response.data?.updateContactName ?? false;
};
